import { PhoneNumber } from '@dreryk/phone-number-common-api';

import { FormContextValues, Validate } from '@dreryk/react-common';
import { PhoneNumberInput } from '@dreryk/react-components';

import { translationKeys } from '../translations';

const PHONE_NUMBER_FIELD_NAME = 'phoneNumber';

export type PhoneNumberFormBeanPart = { [PHONE_NUMBER_FIELD_NAME]: PhoneNumber | null };

type PhoneNumberFieldProps = Pick<FormContextValues<PhoneNumberFormBeanPart>, 'register'> & {
   readonly onValidate: Validate;
};

export const PhoneNumberField = (props: PhoneNumberFieldProps): JSX.Element => {
   return (
      <PhoneNumberInput
         controller={props.register(PHONE_NUMBER_FIELD_NAME, {
            validate: props.onValidate,
         })}
         label={translationKeys.phoneNumber}
         testId={PHONE_NUMBER_FIELD_NAME}
      />
   );
};
